import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import {
  NotificationResponse,
  NotificationValues,
} from "src/app/store/models/global.model";
import { faBell } from "@fortawesome/free-solid-svg-icons";

import { AppService } from "src/app/app.service";
import { Router } from "@angular/router";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { Dictionary } from "@va/core-library/common";
import {
  VAIconRegistryService,
  ellipsisVertical,
  infoCircle,
} from "@va/core-library/icons";

@Component({
  selector: "app-activity-feed",
  templateUrl: "./activity-feed.component.html",
  styleUrls: ["./activity-feed.component.scss"],
  host: { class: "activity-feed-component" },
  encapsulation: ViewEncapsulation.None,
})
export class ActivityFeedComponent implements OnInit, OnChanges {
  @Input() defaultData: {
    companyId?: number;
    showAlertPopover: boolean;
    type: string;
    showWatchlist?: boolean;
  };
  companyId: number;
  legacyUrl = `${window.caUrl}/app`;
  listOfData: Array<any> = [];
  data: Array<Dictionary<any>> = [];
  activityFeedType = "all";
  loading = true;
  eventNameTooltip = "";
  faBell = faBell;
  userId: string;
  showWatchlist = false;
  subscription: Subscription;
  subscription1: Subscription;
  watcherId;
  showAlertPopover = false;
  showAlerts = false;
  dataSubscription: Subscription;
  headerTabs = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "My Alerts",
      value: "alerts",
    },
  ];

  constructor(
    private appService: AppService,
    private router: Router,
    private store: Store<AppState>,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([ellipsisVertical, infoCircle]);
  }

  ngOnInit() {
    this.watcherId = 0;
    this.subscription1 = this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        this.userId = data.userId;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.defaultData &&
      changes.defaultData.currentValue !== changes.defaultData.previousValue
    ) {
      this.listOfData = [];
      this.companyId = this.defaultData.companyId;
      this.activityFeedType = this.defaultData.type;
      this.showAlertPopover = this.defaultData.showAlertPopover;
      this.showWatchlist = this.defaultData.showWatchlist;
      this.watcherId = 0;
      this.getData(changes.defaultData.firstChange);
    }
  }

  getData(isFirstChange?) {
    const params = {
      companyId: this.companyId,
      type: this.activityFeedType,
      watcherId: this.watcherId,
      limit: 50,
    };
    if (this.showAlertPopover) {
      params["type__name_not"] = "ModelArrivedFromBroker";
    }
    if (this.listOfData.length !== 0) {
      // getting last eventPublishTime here (for lazy loading)
      params["eventPublistTime"] = this.listOfData
        .slice(-1)
        .pop()
        .subvalues.slice(-1)
        .pop().eventPublishTime;
    } else {
      this.loading = true;
    }
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    this.dataSubscription = this.appService
      .getActivityFeedData(params)
      .subscribe(
        (response: NotificationResponse) => {
          if (
            response.values.length === 0 &&
            isFirstChange &&
            this.activityFeedType === "alerts"
          ) {
            this.activityFeedType = "all";
            this.onChangeActivityFeedType(this.activityFeedType);
            return;
          }
          if (this.listOfData.length === 0) {
            this.listOfData = [...response.values];
            this.getFormattedData(this.listOfData);
          } else {
            response.values.forEach((value: NotificationValues) => {
              const uniqueID = value.uniqueID;
              const existingValueIndex = this.listOfData.findIndex(
                (data) => data.uniqueID === uniqueID,
              );
              if (existingValueIndex !== -1) {
                this.listOfData[existingValueIndex].subvalues = [
                  ...this.listOfData[existingValueIndex].subvalues,
                  ...value.subvalues,
                ];
              } else {
                this.listOfData.push(value);
              }
            });
            this.getFormattedData(this.listOfData);
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          throw error;
        },
      );
  }

  onChangeActivityFeedType(tabName) {
    this.activityFeedType = tabName;
    this.listOfData = [];
    this.getData();
  }

  onClickRevision(ticker: string) {
    this.router.navigate(["company", `${ticker}`, "revisions"]);
  }

  onScroll() {
    this.getData();
  }

  onclickDownloadModel(rowData) {
    const extra = JSON.parse(rowData.extras);
    const extraParams = {
      companyId: rowData.actor.actor_id,
      cut: "HOME",
      source: rowData.object.object_text,
      pg: "",
      transactionId: extra.transactionid,
    };

    this.appService.excelDownload("model_download", extraParams);
  }
  selectWatchlistFunc(data) {
    this.watcherId = data;
    this.listOfData = [];
    this.loading = true;
    this.getData();
  }
  closeAlertsPopover(row, visible: boolean) {
    row.visibleAlerts = visible;
  }
  ngOnDestroy() {
    if (this.subscription1) this.subscription1.unsubscribe();
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
  getFormattedData(activiyFeedData: Array<any>) {
    this.data = [];
    for (const dataT of activiyFeedData) {
      let rowData = [];
      for (const rowDataT of dataT.subvalues) {
        rowData = [
          ...rowData,
          {
            isAlertEnabled: rowDataT.is_alert_enabled,
            showBell: rowDataT.is_alert_enabled,
            showInfoCircle:
              rowDataT.watchlist_info.length > 0 &&
              rowDataT.is_alert_enabled === false,
            ticker: rowDataT.actor.actor_text,
            actorId: rowDataT.actor.actor_id,
            publishDate: rowDataT.publish_datetime,
            visibleAlerts: rowDataT.visibleAlerts,
            subValues: rowDataT,
          },
        ];
      }
      this.data = [
        ...this.data,
        {
          header: {
            text: dataT.subHeadText,
            date: dataT.headerText,
          },
          row: [...rowData],
        },
      ];
    }
  }
}
